import { RouteConfig } from "../../types/RouteConfig";
import { purchaseTrainingRoute } from "./purchase-training/route";
import { traineesRoute } from "./trainees/route";
import { certificatesRoute } from "./certificates/route";
import { invitesRoute } from "./invites/routes";
import { traineeRoute } from "./trainee/route";
import { enrollmentsRoute } from "./enrollments/route";

export const trainingRoutes: RouteConfig<'with-children'> = {
    name: 'Training',
    icon: 'mdi mdi-dumbbell',
    children: [traineesRoute, traineeRoute, purchaseTrainingRoute, enrollmentsRoute, certificatesRoute, invitesRoute],
}